/* unplugin-vue-components disabled */import script from "./Zhyq.vue?vue&type=script&lang=ts&setup=true"
export * from "./Zhyq.vue?vue&type=script&lang=ts&setup=true"

import "./Zhyq.vue?vue&type=style&index=0&id=d6740c26&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6740c26"]])

export default __exports__